import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastNotification = () => {
  return (
    <div>
      <ToastContainer />
    </div>
  );
}
export default ToastNotification;